"use client";

import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import Link from "next/link";
import { Check } from "lucide-react";

export default function PricingPage() {
  return (
    <div className="flex flex-col min-h-screen bg-white dark:bg-black transition-colors duration-300">
      <Header />
      <main className="flex-1 py-20 px-6">
        <div className="container mx-auto max-w-5xl text-center">
          <h1 className="text-4xl font-bold mb-6 text-gray-900 dark:text-white">합리적인 요금제</h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-16">
            팀의 규모와 채용 빈도에 맞는 플랜을 선택하세요.
          </p>

          <div className="grid md:grid-cols-3 gap-8 text-left">
            {/* Free */}
            <div className="border border-gray-200 dark:border-gray-800 rounded-2xl p-8 hover:shadow-lg transition">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Starter</h3>
              <p className="text-gray-500 mb-6 text-sm">소규모 채용이나 개인 테스트용</p>
              <div className="text-4xl font-bold text-gray-900 dark:text-white mb-6">₩0 <span className="text-base font-normal text-gray-500">/월</span></div>
              <Link href="/upload" className="block w-full text-center py-3 rounded-lg border border-gray-300 dark:border-gray-700 font-bold hover:bg-gray-50 dark:hover:bg-gray-800 transition">
                무료로 시작하기
              </Link>
              <ul className="mt-8 space-y-4">
                <li className="flex gap-3 text-sm text-gray-700 dark:text-gray-300">
                  <Check className="w-5 h-5 text-blue-500" /> 월 3건 분석 무료
                </li>
                <li className="flex gap-3 text-sm text-gray-700 dark:text-gray-300">
                  <Check className="w-5 h-5 text-blue-500" /> 기본 리포트 제공
                </li>
              </ul>
            </div>

            {/* Pro */}
            <div className="border-2 border-blue-600 rounded-2xl p-8 shadow-xl relative transform scale-105 bg-white dark:bg-gray-900">
              <div className="absolute top-0 right-0 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg">POPULAR</div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Pro</h3>
              <p className="text-gray-500 mb-6 text-sm">성장하는 스타트업을 위한 플랜</p>
              <div className="text-4xl font-bold text-gray-900 dark:text-white mb-6">₩9,900 <span className="text-base font-normal text-gray-500">/월</span></div>
              <Link href="#" className="block w-full text-center py-3 rounded-lg bg-blue-600 text-white font-bold hover:bg-blue-700 transition">
                지금 구독하기
              </Link>
              <ul className="mt-8 space-y-4">
                <li className="flex gap-3 text-sm text-gray-700 dark:text-gray-300">
                  <Check className="w-5 h-5 text-blue-500" /> 월 50건 분석
                </li>
                <li className="flex gap-3 text-sm text-gray-700 dark:text-gray-300">
                  <Check className="w-5 h-5 text-blue-500" /> 심층 면접 질문 생성
                </li>
                <li className="flex gap-3 text-sm text-gray-700 dark:text-gray-300">
                  <Check className="w-5 h-5 text-blue-500" /> PDF 리포트 다운로드
                </li>
              </ul>
            </div>

            {/* Enterprise */}
            <div className="border border-gray-200 dark:border-gray-800 rounded-2xl p-8 hover:shadow-lg transition">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Enterprise</h3>
              <p className="text-gray-500 mb-6 text-sm">대규모 채용 및 API 연동</p>
              <div className="text-4xl font-bold text-gray-900 dark:text-white mb-6">문의 <span className="text-base font-normal text-gray-500">/별도협의</span></div>
              <Link href="/enterprise" className="block w-full text-center py-3 rounded-lg border border-gray-300 dark:border-gray-700 font-bold hover:bg-gray-50 dark:hover:bg-gray-800 transition">
                도입 문의하기
              </Link>
              <ul className="mt-8 space-y-4">
                <li className="flex gap-3 text-sm text-gray-700 dark:text-gray-300">
                  <Check className="w-5 h-5 text-blue-500" /> 무제한 분석
                </li>
                <li className="flex gap-3 text-sm text-gray-700 dark:text-gray-300">
                  <Check className="w-5 h-5 text-blue-500" /> 사내 채용 시스템 연동 (API)
                </li>
                <li className="flex gap-3 text-sm text-gray-700 dark:text-gray-300">
                  <Check className="w-5 h-5 text-blue-500" /> 전담 매니저 지원
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
